import { LogOutIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@dotfile/frontend/shared/common';
import { Icon, IconButton } from '@dotfile/frontend/shared/design-system';

import { useLogout } from '../../hooks';

export const LogoutButton = () => {
  const { t } = useTranslation();
  const {
    auth: { isAuthenticated },
  } = useAuth();

  const [logout, { loading }] = useLogout();

  return (
    isAuthenticated && (
      <IconButton
        isLoading={loading}
        onClick={() => logout()}
        icon={<Icon as={LogOutIcon} />}
        aria-label={t('logout', {
          ns: 'client-portal',
          defaultValue: 'Log out',
        })}
      />
    )
  );
};
